// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"1140":"1c7a0822571e8a6e6f66","2221":"142100faf8009dfdd6c5","5448":"43a0c1a4de611c86fdb0","6015":"48e9ef6667af490727df","7859":"6370f79199d15ed88553","7910":"b07879742b315c8682d2","8815":"314a6c3611bff3e07093"}[chunkId] + "";
};